import { useEffect, useState } from 'react';
import { Container, Typography, Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@mui/material';
import { listCompanies, createCompany, updateCompany, deleteCompany, type Company } from '../api/companyApi';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Companies() {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState<Company | null>(null);
  const [form, setForm] = useState<Partial<Company>>({ name: '', type: 'shipper' });

  const load = async () => { setCompanies(await listCompanies()); };
  useEffect(() => { load(); }, []);

  const onSubmit = async () => {
    if (!form.name || !form.type) return;
    if (editing) {
      const updated = await updateCompany(editing.id, { name: form.name, type: form.type as any });
      setCompanies((prev) => prev.map((c) => c.id === updated.id ? updated : c));
    } else {
      const created = await createCompany({ name: form.name!, type: form.type as any });
      setCompanies((prev) => [created, ...prev]);
    }
    setOpen(false); setEditing(null); setForm({ name: '', type: 'shipper' });
  };

  const onEdit = (c: Company) => { setEditing(c); setForm({ name: c.name, type: c.type }); setOpen(true); };
  const onDelete = async (c: Company) => { if (confirm('Supprimer cette compagnie ?')) { await deleteCompany(c.id); setCompanies((prev) => prev.filter((x) => x.id !== c.id)); } };

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h4">Compagnies</Typography>
          <Typography color="text.secondary">Gérez les donneurs d'ordre (shipper/receiver).</Typography>
        </Box>
        <Button variant="contained" onClick={() => { setEditing(null); setForm({ name: '', type: 'shipper' }); setOpen(true); }}>+ Ajouter</Button>
      </Box>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Nom</TableCell>
            <TableCell>Type</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {companies.map((c) => (
            <TableRow key={c.id} hover>
              <TableCell>{c.name}</TableCell>
              <TableCell>{c.type}</TableCell>
              <TableCell align="right">
                <IconButton onClick={() => onEdit(c)}><EditIcon /></IconButton>
                <IconButton color="error" onClick={() => onDelete(c)}><DeleteIcon /></IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editing ? 'Modifier une compagnie' : 'Nouvelle compagnie'}</DialogTitle>
        <DialogContent>
          <Box mt={1} display="grid" gap={2}>
            <TextField label="Nom" value={form.name || ''} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} fullWidth />
            <TextField select label="Type" value={form.type || 'shipper'} onChange={(e) => setForm((f) => ({ ...f, type: e.target.value as any }))} fullWidth>
              <MenuItem value="shipper">Shipper</MenuItem>
              <MenuItem value="receiver">Receiver</MenuItem>
            </TextField>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Annuler</Button>
          <Button onClick={onSubmit} variant="contained">Enregistrer</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
